export const BOOK_SOURCE = "karnovbooks";

// A book starts only from Backoffice (P2-D3). Detect a book by its source string.
export const isBookSource = (source?: string | null): boolean => source === BOOK_SOURCE;
